import dayjs from "dayjs";
import React, { useEffect, useState, useCallback } from "react";
import { FaPlus } from "react-icons/fa";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import AddBoxIcon from '@mui/icons-material/AddBox';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import debounce from "lodash.debounce";
import { allowedUsers } from '../allowedUsers';
import { getPracticeId, patientPhotoUrl } from '../../config/practice';

const CarotidModal = ({ ismodal, setIsmodal, data }) => {
  
  const[isLoading,setIsLoading]=useState(false)

  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const practiseid = getPracticeId();
  const [prevExamData, setPrevExamData] = useState([]);
  const [loading, setLoading] = useState(false);
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const userConfig = useSelector((state) => state.userconfig);
  const calculateAge = (dob) => {
 
    const birthDate = dayjs(dob);
    const today = dayjs();
    return today.diff(birthDate, "year");
  };


  const age = calculateAge(data?.dob);
  const [formData, setFormData] = useState({
    take: "",
    tape: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    requestedby: "DR. MADHU PAMGANAMAMULA",
    technician: "ART MONTANA",
    // history: ['history1', 'history2', 'history3', 'history4','history5', 'history6', 'history7', 'history8'],
    history: [{ value: "", suggestions: [] }],
    signoff: "",
    BPR: { 
      bpr: "",
      distalica: "",
      proxica: "",
      proxeca: "",
      proxcca: "",
      icaccaratio: "",
      },
    BPL: { 
      bpl: "",
      distalica: "",
      proxica: "",
      proxeca: "",
      proxcca: "",
      icaccaratio: "",
      },
    technicianComments: [
      { id: 1, label: '', value: '' },
      { id: 2, label: '', value: '' },
      { id: 3, label: 'ALL VELOCITIES ARE NORMAL', options: [ 'ALL VELOCITIES ARE NORMAL'] },
      { id: 4, label: 'VERTEBRAL, LEFT AND RIGHT, ANTEGRADE NORMAL', options: [ 'VERTEBRAL, LEFT AND RIGHT, ANTEGRADE NORMAL'] },
      { id: 5, label: 'NO HEMODYNAMICALLY SIGNIFICANT LESIONS', options: [ 'NO HEMODYNAMICALLY SIGNIFICANT LESIONS'] },
      { id: 6, label: '', value: '' },
      { id: 7, label: '', value: '' },
      { id: 8, label: '', value: '' }
    ],
  })

const [loadingMessages, setLoadingMessages] = useState([]);
const debouncedApiCall = useCallback(
  debounce(async (value, index) => {
    setLoadingMessages((prev) => {
      const updatedMessages = [...prev];
      updatedMessages[index] = "Loading..."; // Set loading for current index
      return updatedMessages;
    });
    try {
      const response = await api.post(
        `/v1/fhir-mirror/${practiseid}/patient/${data.patientid}/diagnosis/search`,
        {
          searchflag: value,
          limit: 20,
        }
      );

      console.log("API RESPONSE:", response);

      setFormData((prev) => {
        const updatedHistory = [...prev.history];

        let suggestions = [];

        // ✅ HANDLE BOTH CASES (array OR single object)
        if (Array.isArray(response.data)) {
          console.log("API RESPONSE SUGGESTIONS:", response.data);
          suggestions = response.data;
        } else if (response.data) {
          suggestions = [response.data]; // ✅ wrap single object
        }        
        
        updatedHistory[index] = {
          ...updatedHistory[index],
          suggestions,
        };

        return {
          ...prev,
          history: updatedHistory,
        };
      });

    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setLoadingMessages((prev) => {
        const updatedMessages = [...prev];
        updatedMessages[index] = "Error loading data."; // Set error message for the current field
        return updatedMessages;
      });
    } finally {
        // Reset the loading message for the specific index when finished
        setLoadingMessages((prev) => {
          const updatedMessages = [...prev];
          updatedMessages[index] = null; // Reset the loading message
          return updatedMessages;
        });
      }
  }, 500),
  []
);



const fetchdata = async () => {

  try {
   setLoading(true);
    const examtype = "CAROTID";
    const response = await api.get(
      `/v1/${practiseid}/imaging/patient/${data.patientid}/get-previous-exam/${examtype}`
    );

    if (response?.status === 200 && response?.data?.length > 0) {
      console.log("Raw API Response for Previous Exams:", response.data);
      // const raw = response?.data[0] ? [response.data[0]] : [];
      const raw = response?.data?.map((exam) => {
        // Optionally, parse the JSON data inside each exam
        let parsedData = {};
        try {
          parsedData = JSON.parse(exam.data);
        } catch (err) {
          console.error("Failed to parse exam.data", err);
        }

        return {
          ...exam,
          parsedData,
        };
      }) || [];

      console.log("Parsed Previous Exam Data:", raw);
      setPrevExamData(raw);
      setLoading(false);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    setLoading(false);
  }
};

useEffect(() => {
  if (ismodal) {
    fetchdata();
  }
}, [ismodal]);


// const handleFillFields = (data) => {
//   if (!data) return;

//   let parsedData;
//   try {
//     parsedData = JSON.parse(data);
//   } catch (error) {
//     console.error("Invalid JSON data", error);
//     return;
//   }

//   // Fill formData here
//   setFormData((prev) => ({
//     ...prev,
//     take: parsedData.pat_name || "",
//     tape: "", // if you don't have a corresponding field
//     examDate: parsedData.examDate || "",
//     requestedby: parsedData.createdby || "",
//     technician: parsedData.updatedby || "",
//     history: parsedData.pathistory || [], // assuming you want to populate history array
//     BPR: parsedData.BPR || {}, // if BP R exists in your data
//     BPL: parsedData.BPL || {}, // if BP L exists
//     technicianComments: parsedData.technicianComments || prev.technicianComments
//   }));
// };





const handleFillFields = (examData) => {
  if (!examData) return;

  let parsedData = {};
  try {
    parsedData = typeof examData === "string" ? JSON.parse(examData) : examData;
  } catch (err) {
    console.error("Failed to parse exam data:", err);
    return;
  }

  setFormData((prev) => ({
    ...prev,
    take: parsedData.take || "",
    tape: parsedData.tape || "",
    examDate: parsedData.examDate || "",
    requestedby: parsedData.requestedby || "",
    technician: parsedData.technician || "",

    // History
    history: parsedData.pathistory?.length
      ? parsedData.pathistory.map((h) => ({ value: h.value, suggestions: [] }))
      : [{ value: "", suggestions: [] }],

    // BPR / BPL: handle both existing BPR/BPL or RIGHT/LEFT from older API
    BPR: parsedData.BPR || (parsedData.RIGHT
      ? {
          bpr: parsedData.RIGHT.POP || "",
          distalica: parsedData.RIGHT.ATA || "",
          proxica: parsedData.RIGHT.PTA || "",
          proxeca: parsedData.RIGHT.SFA || "",
          proxcca: parsedData.RIGHT.CFA || "",
          icaccaratio: parsedData.RIGHT.bpabi || "",
        }
      : prev.BPR),

    BPL: parsedData.BPL || (parsedData.LEFT
      ? {
          bpl: parsedData.LEFT.POP || "",
          distalica: parsedData.LEFT.ATA || "",
          proxica: parsedData.LEFT.PTA || "",
          proxeca: parsedData.LEFT.SFA || "",
          proxcca: parsedData.LEFT.CFA || "",
          icaccaratio: parsedData.LEFT.bpabi || "",
        }
      : prev.BPL),

    // Technician Comments
    technicianComments: prev.technicianComments.map((tc) => {
      const match = parsedData.technicianComments?.find((item) => item.id === tc.id);
      if (!match) return tc;

      // For dropdowns (ids 3, 4, 5)
      if ([3, 4, 5].includes(tc.id)) {
        return {
          ...tc,
          dropdown: match.dropdown || match.value || "",
          text: match.text || match.value || "",
        };
      }

      // For normal comments
      return {
        ...tc,
        value: match.value || "",
      };
    }),
  }));
};





const handleChange = async (e, section = null, index = null, type = null, customValue = null) => {
  // const value = customValue ?? e?.target?.value ?? '';
  const value = customValue ?? (e?.target?.type === 'checkbox' ? e.target.checked : e?.target?.value ?? '');
  const name = e?.target?.name ?? null;

  // ✅ BPR / BPL (MAIN FIX)
  if (section === "BPR" || section === "BPL") {
    setFormData((prev) => {
      const updatedSection = {
        ...prev[section],
        [name]: value,
      };

      const distalICA = parseFloat(updatedSection.distalica);
      const proxCCA = parseFloat(updatedSection.proxcca);
      const distalICA_EDV = parseFloat(updatedSection.distalica_edv);
      const proxCCA_EDV = parseFloat(updatedSection.proxcca_edv);

      let icaccaratio = "";
      let edvratio = "";

      // ICA/CCA Ratio (PSV)
      if (!isNaN(distalICA) && !isNaN(proxCCA) && proxCCA !== 0) {
        icaccaratio = (distalICA / proxCCA).toFixed(2);
      }

      // EDV Ratio (CORRECT)
      if (!isNaN(distalICA_EDV) && !isNaN(proxCCA_EDV) && proxCCA_EDV !== 0) {
        edvratio = (distalICA_EDV / proxCCA_EDV).toFixed(2);
      }

      return {
        ...prev,
        [section]: {
          ...updatedSection,
          icaccaratio,
          edvratio,
        },
      };
    });
  }

  // ✅ HISTORY - API Call for Suggestions
else if (section === "history" && index !== null) {
  const inputValue = value;
  console.log("Input Value for Suggestions:", inputValue);
  setFormData((prev) => {
    const updatedHistory = [...prev.history];

    updatedHistory[index] = {
      ...updatedHistory[index],
      value: inputValue,
    };

    // ✅ Ensure last row always exists
    // const last = updatedHistory[updatedHistory.length - 1];
    // if (last.value.trim() !== "") {
    //   updatedHistory.push({ value: "", suggestions: [] });
    // }

    return {
      ...prev,
      history: updatedHistory,
    };
  });

  if (inputValue.trim()) {
    debouncedApiCall(inputValue, index);
  } else {
    setFormData((prev) => {
      const updatedHistory = [...prev.history];
      updatedHistory[index].suggestions = [];
      return { ...prev, history: updatedHistory };
    });
  }
}


  // ✅ TECH COMMENTS
  // else if (section === "technicianComments" && index !== null) {
  //   const updatedComments = [...formData.technicianComments];
  //   updatedComments[index].value = value;

  //   setFormData((prev) => ({
  //     ...prev,
  //     technicianComments: updatedComments,
  //   }));
  // }

else if (section === 'technicianComments' && index !== null) {
  setFormData(prev => {
    const updated = [...prev.technicianComments];

    if (type === 'dropdown') {
      updated[index] = {
        ...updated[index],
        dropdown: value,
        text: value, // ✅ auto-fill right side
      };
    } else if (type === 'text') {
      updated[index] = {
        ...updated[index],
        text: value,
      };
    } else {
      updated[index] = {
        ...updated[index],
        value: value,
      };
    }

    return { ...prev, technicianComments: updated };
  });
}

  // ✅ TOP LEVEL
  else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};

const handleSelectSuggestion = (item, index) => {
  const concatenatedValue = `${item.condition_name}  ${item.icd10}`;

  setFormData((prev) => {
    const updatedHistory = [...prev.history];

    updatedHistory[index] = {
      ...updatedHistory[index],
      value: concatenatedValue, // Use the concatenated value as input value
      suggestions: [],
    };

    // Ensure the last row is always empty for manual input
    const last = updatedHistory[updatedHistory.length - 1];
    if (last.value.trim() !== "") {
      updatedHistory.push({ value: "", suggestions: [] });
    }

    return {
      ...prev,
      history: updatedHistory,
    };
  });
};

// const handleSelectSuggestion = (item, index) => {
//   setFormData((prev) => {
//     const updatedHistory = [...prev.history];

//     updatedHistory[index] = {
//       ...updatedHistory[index],
//       value: item.icd10+' '+item.condition_name,
//       icd10: item.icd10,
//       suggestions: [],
//     };

//     // ✅ Ensure last row always empty
//     const last = updatedHistory[updatedHistory.length - 1];
//     if (last.value.trim() !== "") {
//       updatedHistory.push({ value: "", suggestions: [] });
//     }

//     return {
//       ...prev,
//       history: updatedHistory,
//     };
//   });
// };

  // Handle "Add Manually" button click to add a new input field
  const handleAddManually = () => {
    setFormData(prev => {
      const updatedHistory = [...prev.history];
      updatedHistory.push({ value: '', suggestions: [] }); // Add new empty input field
      return { ...prev, history: updatedHistory };
    });
  };


  const validateForm = () => {
    const errors = [];

    if (!formData.examDate) errors.push("Exam Date is required.");
    //if (!formData.history.trim()) errors.push("Patient History is required.");


    return errors;
  };

  // Reset form data
  const resetFormData = () => {
    setFormData({
    take: "",
    tape: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    requestedby: "",
    technician: "",
    // history: ['history1', 'history2', 'history3', 'history4','history5', 'history6', 'history7', 'history8'],
    history: [{ value: "", suggestions: [] }],
    BPR: { 
      bpr: "",
      distalica: "",
      proxica: "",
      proxeca: "",
      proxcca: "",
      icaccaratio: "",
      },
    BPL: { 
      bpr: "",
      distalica: "",
      proxica: "",
      proxeca: "",
      proxcca: "",
      icaccaratio: "",
      },
    technicianComments: [
      { id: 1, label: '', value: '' },
      { id: 2, label: '', value: '' },
      { id: 3, label: 'ALL VELOCITIES ARE NORMAL', value: '' },
      { id: 4, label: 'VERTEBRAL, LEFT AND RIGHT, ANTEGRADE NORMAL', value: '' },
      { id: 5, label: 'NO HEMODYNAMICALLY SIGNIFICANT LESIONS', value: '' },
      { id: 6, label: '', value: '' },
      { id: 7, label: '', value: '' },
      { id: 8, label: '', value: '' }
    ],
    });
  };

const handleSave = async() => {
  const errors = validateForm();
  if (errors.length > 0) {
    setToastMessage(errors[0]);
    setToastSeverity("error");
    setOpenToast(true);
  } else {
    try {
      setIsLoading(true)
    
    const payload = {
      patient_id: data?.patientid,
      pat_name: `${data?.firstname} ${data?.lastname}`,
      pat_dob: data?.dob,
      examDate: formData.examDate,
      pat_age: age,
      pat_gender: data?.gender?.toUpperCase(),
      encounterid: data?.appointmentid,
      pathistory: formData.history,
      take: formData.take,
      tape: formData.tape,
      requestedby: formData.requestedby,
      technician: formData.technician,
    BPR: formData.BPR,
    BPL:formData.BPL,
    technicianComments: formData.technicianComments,
    signoff: formData?.signoff || '',   
    };
    const user=await api.get('/auth/me')
    const [year, month, day] = formData.examDate.split("-");
    const formattedDate = `${month}/${day}/${year}`;


const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
  "Worksheet_Type": "CAROTID",
  "createdby": user?.username || '',
  "appurl": window.location.origin,
    // "appurl": "https://api.prd.brainymed.com",
  "Exam_Date": formattedDate,
  "data": payload
});

if(response.status==200){
  const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
  "filename": response?.data?.filename,
  "documenttypeid": response?.data?.documenttypeid,
  "worksheet_type": "CAROTID",
  "appurl": window.location.origin,
  "exam_date": formattedDate
  })
  setToastMessage("Form Submitted Successfully");
    setToastSeverity("success");
    setOpenToast(true);
 setTimeout(() => {
  resetFormData()
  setIsmodal(false);
}, 1000);

}else{
  setToastMessage(response.message);
    setToastSeverity("info");
    setOpenToast(true);
}
    } catch (error) {
      console.log(error)
        setToastMessage("Something Went Wrong");
    setToastSeverity("error");
    setOpenToast(true);
    }finally{
setIsLoading(false)

    }
  }
};




  if (!ismodal) return null;


    return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">CAROTID</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">
            &times;
          </button>
        </div>
        <hr className="mb-4 border-gray-300" />

        {/* Patient Info */}
        <div className="flex items-center space-x-4 mb-4">
          <img

            src={patientPhotoUrl(data.patientid)}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
          <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
  #{data?.patientid}
</div>

            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold"   >Age:</span> {age} &nbsp;|&nbsp;
              <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>



{prevExamData.length > 0 && (
<table className="min-w-full text-sm text-left border border-gray-300">
      
        <thead className="bg-gray-200">
          <tr>
            <th colSpan="7" className="border px-3 py-2 font-semibold text-[#8B1818] text-center">Previous Exam Data</th>
          </tr>
          <tr>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Exam</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Patient ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Date of Service</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Created By</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Action</th>
          </tr>
        </thead>
      

      <tbody className="border divide-y divide-gray-200">
        {prevExamData.length > 0 ? (
          prevExamData.map((exam) => (
            <tr key={exam.id} className="border hover:bg-gray-50">
              <td className="border px-3 py-2">{exam.id}</td>
              <td className="border px-3 py-2">{exam.exam}</td>
              <td className="border px-3 py-2">{exam.patientid}</td>
              <td className="border px-3 py-2">{exam.dateofservice ? dayjs(exam.dateofservice).format("MM-DD-YYYY") : ""}</td>
              <td className="border px-3 py-2">{exam.createdby}</td>
              <td className="border px-3 py-2">
                  <AddBoxIcon onClick={() => handleFillFields(exam.data)} className="cursor-pointer text-gray-700 hover:text-gray-900" />
              </td>
            </tr>
          ))
        ) : (
          <tr>
              <td colSpan="7" className="px-3 py-2 text-center text-gray-500">
                {loading ? "Getting Records ..." : " No records found"}
              </td>
          </tr>
        )}
      </tbody>
    </table>
)}



{/* Chart  */}
        <div className="grid grid-cols-4 gap-4 py-4">
            <div>
                <label className="block text-sm font-medium mb-1">Chart #</label>
                <input
                type="number"
                step="0.01"
                inputMode="decimal"
                className="border rounded px-2 py-1 w-full"
                value={data?.patientid} readOnly
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Take</label>
                <input
                type="text"
                name="take" 
                className="border rounded px-2 py-1 w-full"
                value={formData.take} 
                onChange={handleChange}
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Tape</label>
                <input
                type="text"
                name="tape"
                className="border rounded px-2 py-1 w-full"
                value={formData.tape} 
                onChange={handleChange}
                />
            </div>
          <div>
            <label className="block text-sm font-medium mb-1">Date(mm/dd/yyyy)</label>
            <input
              type="date"
              name="examDate"
              className="w-full border rounded px-2 py-1"
              value={formData.examDate}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Registered and Technician */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Requested by</label>
            <input
                type="text"
                value={formData.requestedby}
                name="requestedby"
                onChange={handleChange}
                className="w-full border rounded px-2 py-1"
            />
          </div>
       
          <div>
            <label className="block text-sm font-medium mb-1">Technician</label>
            <input
                type="text"
                value={formData.technician}
                name="technician" 
                onChange={handleChange}
                className="w-full border rounded px-2 py-1"
            />
          </div>
        </div>

        {/* History */}
        {/* <div className="mt-4">
          <label className="block text-sm font-medium"> History</label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
              {formData.history.map((hist, index) => (
                <div key={index}>
                  <input
                    type="text" placeholder="Enter text here..."
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={hist.value || ''}
                    onChange={(e) => handleChange(e, 'history', index)}  
                  />
                </div>
              ))}
            </div>
        </div> */}





   <div>
      <div className="mt-4">
        <div className="flex justify-between items-center">
        <label className="block text-sm font-medium">History</label>

        {/* "Add Manually" Button (only appears once at the top) */}
        {!formData.addManual && (
          <div className="">
            <ControlPointIcon            
            className="w-8 cursor-pointer"
            onClick={handleAddManually}
            alt="+"
          />
          </div>
        )}
        </div>


        <div className="grid grid-cols-1 gap-6 mb-6">
          {formData.history.map((hist, index) => (
            <div key={index} className="relative">

              {/* INPUT FIELD */}
              <input
                type="text"
                placeholder="Enter text here..."
                className="w-full border rounded px-3 py-2 mt-1"
                value={hist?.value || ""}
                onChange={(e) => handleChange(e, "history", index)}
                onInput={(e) => debouncedApiCall(e.target.value, index)} // Trigger API call for suggestions
              />

              {/* Display the loading message for the specific input field */}
              {loadingMessages[index] && (
                <div className="absolute top-full mt-1 text-sm text-gray-500">
                  {loadingMessages[index]}
                </div>
              )}

              {/* DROPDOWN (If suggestions exist) */}
              {Array.isArray(hist?.suggestions) && hist.suggestions.length > 0 && (
                <ul className="absolute left-0 top-full mt-1 w-full border max-h-40 overflow-y-auto bg-white shadow-lg rounded z-50">
                  {hist.suggestions.map((item, i) => (
                    <li
                      key={item.id || i}
                      className="px-3 py-2 cursor-pointer hover:bg-gray-200"
                      onClick={() => handleSelectSuggestion(item, index)}
                    >
                      <div className="font-medium">
                        {item?.condition_name || "No Name"}
                      </div>
                      {item?.icd10 && (
                        <div className="text-xs text-gray-500">
                          ICD: {item.icd10}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>

    

    <div className="py-1 mt-3">
      {/* BP R Section */}
      <div className="grid grid-cols-2 gap-6 mb-2">
        <div className="border p-3">
          <h6 className="text-xl font-semibold mb-2">BP R</h6>
          <div className="space-y-4">
            <div>
              {/* BPR */}
              <input
                type="text"
                name="bpr"
                className="w-full border rounded px-3 py-2 mt-1"
                value={formData.BPR.bpr || ""}
                onChange={(e) => handleChange(e, "BPR")}
                placeholder="/"
              />
            </div>
            <div className="bg-gray-300 text-black p-1"> :: R PSV/EDV</div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">DISTAL ICA </label>
                <input
                      type="text"
                      name="distalica"
                      className="w-full border rounded px-3 py-2 mt-1"
                      value={formData.BPR.distalica || ""}
                      onChange={(e) => handleChange(e, "BPR")}
                    />
            </div>
            
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ICA </label>
                <input
                  type="text"
                  name="proxica"
                  className="w-full border rounded px-3 py-2 mt-1"
                  value={formData.BPR.proxica || ""}
                  onChange={(e) => handleChange(e, "BPR")}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ECA </label>
                <input
                  type="text"
                  name="proxeca"
                  className="w-full border rounded px-3 py-2 mt-1"
                  value={formData.BPR.proxeca || ""}
                  onChange={(e) => handleChange(e, "BPR")}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX CCA </label>
                <input
                  type="text"
                  name="proxcca"
                  className="w-full border rounded px-3 py-2 mt-1"
                  value={formData.BPR.proxcca || ""}
                  onChange={(e) => handleChange(e, "BPR")}
                />
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">ICA/CCA RATIO</label>
                  <input
                    type="text"
                    className="w-full border rounded px-3 py-2 mt-1 bg-gray-100"
                    value={formData.BPR.icaccaratio || ""}
                    onChange={(e) => handleChange(e, 'BPR')}
                  />
            </div>

          </div>
        </div>

        {/* BP L Section */}
        <div className="border p-3">
          <h6 className="text-xl font-semibold mb-2">BP L</h6>
          <div className="space-y-4">
            <div>
              <input
                type="text" name="bpl"
                className="w-full border rounded px-3 py-2 mt-1"
                value={formData.BPL.bpl || ""} placeholder="/"
                onChange={(e) => handleChange(e, 'BPL')}
              />
            </div>
            <div className="bg-gray-300 text-black p-1"> :: L PSV/EDV</div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">DISTAL ICA </label>
                <input
                    type="text" name="distalica"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.BPL.distalica  || ""} placeholder="/"
                    onChange={(e) => handleChange(e, 'BPL')}
                />
            </div>
            
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ICA </label>
                <input
                    type="text" name="proxica"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.BPL.proxica  || ""} placeholder="/"
                    onChange={(e) => handleChange(e, 'BPL')}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ECA </label>
                <input
                    type="text" name="proxeca"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.BPL.proxeca  || ""} placeholder="/"
                    onChange={(e) => handleChange(e, 'BPL')}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX CCA </label>
                <input
                    type="text" name="proxcca"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.BPL.proxcca  || ""} placeholder="/"
                    onChange={(e) => handleChange(e, 'BPL')}
                />
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">ICA/CCA RATIO</label>
                <input
                    type="text" name="icaccaratio"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.BPL.icaccaratio  || ""} placeholder="/"
                    onChange={(e) => handleChange(e, 'BPL')}
                />
            </div>

          </div>
        </div>

      </div>
      </div>


      {/* Technician's  Comments */}
<div className="py-8">
  <h2 className="text-xl font-semibold">
    {allowedUsers.includes(userConfig?.username) ? (
      <div>IMPRESSIONS</div>
    ) : (
      <div>TECHNICIAN COMMENTS</div>
    )}  
  </h2>
  <div className="grid gap-6 mb-8">
    <div className="space-y-4">
      {formData.technicianComments.map((comment, index) => (
        <div key={comment.id}>
          {/* Dropdown for id 3, 4, and 5 */}
          {comment.id === 3 || comment.id === 4 || comment.id === 5 ? (
            <div className="grid grid-cols-2 gap-2 py-1">
              <div>
                {/* Dropdown for specific technician comments */}
                <select
                  className="w-full border rounded px-3 py-2 mt-1"
                  value={formData.technicianComments[index].dropdown || ''}
                  onChange={(e) =>
                    handleChange(e, 'technicianComments', index, 'dropdown')
                  }
                >
                  <option value="">Select an option</option>
                  {comment.options?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div>                
                  {/* {comment.label} */}
                  <input
                    type="text"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.technicianComments[index].text || ''}
                    onChange={(e) =>
                      handleChange(e, 'technicianComments', index, 'text')
                    }
                  />                
              </div>
            </div>
          ) : (
            <div>
              {/* For non-dropdown comments, use a textarea */}
              <label className="block text-sm font-medium text-gray-700">
                {comment.label}
              </label>
              <textarea
                placeholder="Enter Comments here..."
                name="technicianComments"
                rows={2}
                className="w-full border rounded px-2 py-1 mt-1"
                value={formData.technicianComments[index]?.value || ''}
                onChange={(e) => handleChange(e, 'technicianComments', index)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</div>

    <div className="py-8">
      {/* Action Buttons */}
      <div className="flex justify-between items-center">
        <div>

        {allowedUsers.includes(userConfig?.username) ? (
          <div className="flex flex-col items-start p-4 bg-white shadow-md rounded-lg border border-gray-200 w-80">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                name="signoff"
                checked={formData.signoff || false}
                onChange={handleChange}
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span className="ml-3 font-semibold text-gray-700 text-lg">Sign Off</span>
            </label>

            {formData.signoff && (
              <>
              <div className="mt-3 flex items-center space-x-3">
                <img
                  src={DrMadhuSign}
                  alt="Signed Off"
                  className="h-20 rounded-lg shadow-md animate-fadeIn"
                />
                <span className="text-green-600 font-medium">Successfully Signed!</span>
              </div>
              <div className="py-2 font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
              </>
            )}
          </div>
        ) : (
          <div className=""></div>
        )}

        {/* <button className="text-blue-500 text-sm hover:text-blue-700">
          [ PRINT PREVIEW ]
        </button> */}
        </div>
        <div>
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600"
          >
            Save Report
          </button>
          {/* <button            
            className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 ml-4"
          >
            Update Report
          </button> */}
          <button
            
            className="bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 ml-4"
          >
            Clear Data
          </button>
        </div>

      </div>
    </div>

    
</div>

   <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
    </div>
  );
};

export default CarotidModal;
